import { render } from "./Sublinks.vue?vue&type=template&id=86a6aa1a"
import script from "./Sublinks.vue?vue&type=script&lang=js"
export * from "./Sublinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__